module.exports = __webpack_public_path__ + "media/images/sp/stores/common/instagram/photographer_sns_05-7a3a981615be7977c717e1390e9ce22d.jpg";